import React from 'react';
import { Youtube, Instagram, MessageCircle, Heart } from 'lucide-react';
import { socialLinks } from '../data/mock';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">AstroClick</h3>
            <p className="footer-text">
              Illuminating your path through ancient Vedic wisdom and modern astrological insights.
            </p>
            <div className="footer-social">
              <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer" className="footer-social-icon">
                <Instagram size={20} />
              </a>
              <a href={socialLinks.whatsapp} target="_blank" rel="noopener noreferrer" className="footer-social-icon">
                <MessageCircle size={20} />
              </a>
              <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer" className="footer-social-icon">
                <Youtube size={20} />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><button onClick={() => document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' })}>Home</button></li>
              <li><button onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}>About</button></li>
              <li><button onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}>Services</button></li>
              <li><button onClick={() => document.getElementById('testimonials')?.scrollIntoView({ behavior: 'smooth' })}>Testimonials</button></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-links">
              <li><a href="#">Birth Chart Analysis</a></li>
              <li><a href="#">Horoscope Predictions</a></li>
              <li><a href="#">Gemstone Consultation</a></li>
              <li><a href="#">Personalized Readings</a></li>
            </ul>
          </div>

          <div className="footer-section youtube-section">
            <h4 className="footer-heading">Subscribe to Our Channel</h4>
            <p className="footer-text">
              Watch weekly horoscopes, astrological insights, and spiritual guidance
            </p>
            <a 
              href={socialLinks.youtube} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="youtube-button"
            >
              <Youtube size={24} />
              <span>Visit Our Channel</span>
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              © 2025 AstroClick. All rights reserved.
            </p>
            <p className="copyright">
              Designed and built by Deeptanshu Sharma
            </p>
            <p className="made-with">
              Made with <Heart size={14} fill="#EECE7B" color="#EECE7B" /> for seekers of cosmic wisdom
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;